export default __webpack_public_path__ + "static/media/save-the-planet.ed1de808.svg";